import * as React from "react";
import * as AuthStore from "../store/Auth";
import { ApplicationState } from '../store';
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { fetchData } from '../utils';
import { Button, Select, Card, message, Row, Col, Tabs } from 'antd';
import {
    ReloadOutlined, DiffOutlined, TagsOutlined, MedicineBoxOutlined,
    FileSearchOutlined, FileDoneOutlined, SolutionOutlined, ExperimentOutlined,
    WalletOutlined, CarryOutOutlined, OrderedListOutlined, FileAddOutlined,
    CopyOutlined, FormOutlined, FileSyncOutlined, NodeCollapseOutlined,
    NodeExpandOutlined,NodeIndexOutlined
} from '@ant-design/icons/lib';
const { Option } = Select;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class OnboardingAudit extends React.Component<AuthProps>
{
    public state =
    {
        data: [],
        lineList: [],
        stateList: [],
        siteList: [],
        clientSite: false,
        statesLoaded: true,
        siteId: 0,
        loading: false,
        audit: { patients: '0', pharmacy: '0', carecard: '0', pbs: '0', vlSamples: '0', vlResult: '0', clientIntake: '0', artCommencement: '0', hivEnrolment: '0', pmtctHts: '0', ganc: '0', childbirthReg: '0', deliveryReg: '0', adcliniEv: '0', adRskStrat: '0', pedRskStrat: '0', maternalChrt: '0', childFollowup: '0', clrefForm: '0', presTB: '0', clTracking: '0' },
        confirmLoading: false,
        site: { id: 0, name: '', stateName: '', stateCode: '', stateId: '' },
        state: { stateId: 0, stateName: '', stateCode: '', sites: [] },   
        states: [],
        sites: [],
        searchObj:
        {
            stateId: 0,
            state: '',
            site: 0,
            siteId: '',
            siteName: '',
            stateName: ''
         },
        tHeads: [],
        tBody: [],
        showingInfoWindow: false,
        selectedPlace: {name: ''}
    };

    async componentDidMount()
    {    
        let el = this;

        let user = el.props.appUser;     
        let sts = localStorage.getItem("states");
        let states = [];    
        if (sts) states = JSON.parse(sts);

        let sites = [];
        if (user.stateCode && user.stateCode.length > 0)
        {
            var statex = states.filter(s =>
            {
                return s.stateCode.toLocaleLowerCase() === user.stateCode.toLocaleLowerCase();
            });
            if (statex.length > 0)
            {
                let { searchObj } = this.state;
                let state: any = states[0];
                searchObj.stateName = state.stateName;
                searchObj.stateId = state.stateId;
                this.setState({ state, searchObj });
            }
        }

        let statesLoaded = true;
        this.setState({ states, sites, statesLoaded });
    }
    selectSite(value: any)
    {
        const { searchObj } = this.state;
        if (value)
        {
            searchObj.site = value.key;
            searchObj.siteId = value.key;
            let sites: any = this.state.state.sites.filter(function (o: any) { return o.id === searchObj.site });
            if (sites.length > 0) searchObj.siteName = sites[0].name;
            this.setState({ searchObj });  
        } 
    }
    selectState(value: any)
    {
        if (!value)
        {
            return;
        }

        const { searchObj } = this.state;          
        searchObj.site = 0;
        if (value)
        {
            let val = value.key;
            let states = this.state.states.filter(function (s: any) { return s.stateId === val });
            if (states.length > 0)
            {
                var state = states[0];
                //state.sites = states[0].sites;
                searchObj.stateName = state.stateName;
                searchObj.stateId = state.stateId;
                searchObj.state = state.stateCode;
                this.setState({ state: state, searchObj: searchObj });
            } 
        }        
    }
    reset()
    {           
        this.setState({
            searchObj:
            {
                stateId: 0,
                state: '',
                site: 0,
                siteId: 0,
                siteName: '',
                stateName: ''
            },
            audit: { patients: '0', pharmacy: '0', carecard: '0', pbs: '0', vlSamples: '0', vlResult: '0', clientIntake: '0', artCommencement: '0', hivEnrolment: '0', pmtctHts: '0', ganc: '0', childbirthReg: '0', deliveryReg: '0', adcliniEv: '0', adRskStrat: '0', pedRskStrat: '0', maternalChrt: '0', childFollowup: '0', clrefForm: '0', presTB: '0', clTracking: '0' }});
    }
    
    async qQ()
    {
        let el = this;
        const { searchObj } = el.state;

        if (searchObj.siteId === null || searchObj.siteId === undefined || searchObj.siteId.length < 1 || searchObj.siteId === '0')
        {
            message.error("Please select a Facility");
            return;
        }
        
        el.setState({ audit: { patients:  '0', pharmacy:  '0', carecard:  '0', pbs:  '0', vlSamples:  '0', vlResult:  '0', clientIntake:  '0', artCommencement:  '0', hivEnrolment:  '0', pmtctHts:  '0', ganc:  '0', childbirthReg:  '0', deliveryReg:  '0', adcliniEv:  '0', adRskStrat:  '0', pedRskStrat:  '0', maternalChrt:  '0', childFollowup:  '0', clrefForm:  '0', presTB:  '0', clTracking:  '0' } });   

        var site = searchObj.siteId ? searchObj.siteId : 0;

        el.setState({ loading: true });

        let res = await fetchData('/api/Stats/auditFacility?siteId=' + site);        
        el.setState({ loading: false });
        el.setState({ audit: res });
    }

    render() 
    {
        const { state, loading, states, searchObj, audit} = this.state;
        let user = this.props.appUser;
        let el = this;
        
        return (
            <div style={{marginTop: '15px', padding: '20px'}}>
                <Helmet>
                    <title>CDR :: Onboarding Audit</title>
                </Helmet>    
                <div className="custom-filter-dropdown">      
                    <Row style={{ marginTop: '2px' }}>
                        <Col span={24}>
                            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>Onboarding Audit (Facility)</h4>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="ant-modal-footer si-ant card-container" style={{ paddingTop: '10px' }}>  
                            <Card className="ant-card-body pfs s-list">
                                <Row>
                                    <Col span={24}>                                       
                                        {!user.stateCode && < Row style={{ marginBottom: '8px' }}>
                                            <Col span={24}>
                                                <Select className="circl-radius"
                                                    labelInValue
                                                    showSearch
                                                    optionFilterProp="children"
                                                    disabled={loading}
                                                    //@ts-ignore
                                                    value={{ key: searchObj.stateId }}
                                                    style={{ width: '100%' }}
                                                    placeholder="Select State"
                                                    onChange={(value) => this.selectState(value)}
                                                >
                                                    <Option key={0} value={0}>-- Select State --</Option>
                                                    {states && states.map((s: any) => <Option key={s.stateId} value={s.stateId}>{s.stateName}</Option>)}
                                                </Select>
                                            </Col>
                                        </Row>}
                                        < Row style={{ marginBottom: '8px' }}>
                                            <Col span={24}>
                                                <Select className="circl-radius"
                                                    labelInValue
                                                    showSearch
                                                    optionFilterProp="children"
                                                    disabled={loading}
                                                    style={{ width: '99%', float: 'right' }}
                                                    //@ts-ignore
                                                    value={{ key: searchObj.site }}
                                                    placeholder="Select Site"
                                                    onChange={(value) => this.selectSite(value)}
                                                >
                                                    <Option key={0} value={0}>-- Select Site --</Option>
                                                    {state.sites && state.sites.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                                                </Select>
                                            </Col>
                                        </Row>    
                                        <Row style={{ marginBottom: '8px'}} gutter={2}>
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                                <Button type="default" disabled={loading} className="login-button reset mer-fetch" size="large" onClick={() => this.reset()}>
                                                    <ReloadOutlined /> Reset
                                            </Button>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                                <Button disabled={loading} className="login-button mer-fetch" loading={loading} type="primary" size="large" onClick={() => this.qQ()}>
                                                    {loading ? 'loading...' : 'Fetch Data'}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card>                       
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={18} xl={18} className="ant-modal-footer si-ant card-container" style={{ paddingTop: '10px' }}>
                            <Card className="ant-card-body pfs s-list card-box">                                
                                <Col span={24} className="stat-card">
                                    <Row className="sr row-30px-pad-10px-top">
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.patients.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                {/*<TeamOutlined className="db-i" />*/}
                                                <svg className="bi bi-people db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.995-.944v-.002.002zM7.022 13h7.956a.274.274 0 00.014-.002l.008-.002c-.002-.264-.167-1.03-.76-1.72C13.688 10.629 12.718 10 11 10c-1.717 0-2.687.63-3.24 1.276-.593.69-.759 1.457-.76 1.72a1.05 1.05 0 00.022.004zm7.973.056v-.002.002zM11 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zM6.936 9.28a5.88 5.88 0 00-1.23-.247A7.35 7.35 0 005 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 015 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10c-1.668.02-2.615.64-3.16 1.276C1.163 11.97 1 12.739 1 13h3c0-1.045.323-2.086.92-3zM1.5 5.5a3 3 0 116 0 3 3 0 01-6 0zm3-2a2 2 0 100 4 2 2 0 000-4z" clipRule="evenodd" />
                                                </svg>
                                                <div className="custom-card">
                                                    <h3> Patients &nbsp;</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.hivEnrolment.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>             
                                                <svg className="bi bi-person-check db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" d="M11 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM1.022 13h9.956a.274.274 0 00.014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 00.022.004zm9.974.056v-.002.002zM6 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zm6.854.146a.5.5 0 010 .708l-3 3a.5.5 0 01-.708 0l-1.5-1.5a.5.5 0 01.708-.708L12.5 7.793l2.646-2.647a.5.5 0 01.708 0z" clipRule="evenodd" />
                                                </svg>
                                                <div className="custom-card">
                                                    <h3>HIV Enrolments</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.artCommencement.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <CarryOutOutlined className="db-i" />
                                                <div className="custom-card">
                                                    <h3>ART Commencements&nbsp;</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.carecard.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <SolutionOutlined className="db-i" />
                                                <div className="custom-card">
                                                    <h3>Care cards</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <Row className="sr row-30px-pad-10px-top">
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.pharmacy.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <MedicineBoxOutlined className="bi bi-people db-i"/>
                                                <div className="custom-card">
                                                    <h3>Drug Pickups</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.vlSamples.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <WalletOutlined className="db-i" />
                                                <div className="custom-card">
                                                    <h3>Samples Collected</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.vlResult.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <ExperimentOutlined className="db-i" />
                                                <div className="custom-card">
                                                    <h3>Lab Results</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.clientIntake.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>                                                
                                                <DiffOutlined className="bi bi-people db-i"/>
                                                <div className="custom-card">
                                                    <h3>Client Intake</h3>
                                                </div>
                                            </Card>
                                    </Col>
                                    </Row>
                                    <Row className="sr row-30px-pad-10px-top">
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.pbs.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <OrderedListOutlined className="db-i"/>
                                                <div className="custom-card">
                                                    <h3>Clients with PBS</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.pmtctHts.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <CopyOutlined className="db-i" />
                                                <div className="custom-card">
                                                    <h3>PMTCT HTS</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.ganc.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <FileAddOutlined className="db-i" />
                                                <div className="custom-card">
                                                    <h3>GANC</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.childbirthReg.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <FormOutlined className="db-i" />
                                                <div className="custom-card">
                                                    <h3>Child Birth Registers</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <Row className="sr row-30px-pad-10px-top">
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.deliveryReg.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                {/*<CarryOutOutlined className="db-i"/>*/}
                                                <svg className="db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" d="M11 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM1.022 13h9.956a.274.274 0 00.014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 00.022.004zm9.974.056v-.002.002zM6 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zm4.5 0a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1H13V5.5a.5.5 0 01.5-.5z" clipRule="evenodd" />
                                                    <path fillRule="evenodd" d="M13 7.5a.5.5 0 01.5-.5h2a.5.5 0 010 1H14v1.5a.5.5 0 01-1 0v-2z" clipRule="evenodd" />
                                                </svg>
                                                <div className="custom-card">
                                                    <h3>Delivery Registers</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.maternalChrt.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>                                                
                                                <TagsOutlined className="db-i"/>
                                                <div className="custom-card">
                                                    <h3>Maternal Cohort Registers</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.childFollowup.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <FileSyncOutlined className="db-i" />
                                                <div className="custom-card">
                                                    <h3>Child Followup Registers</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.adcliniEv.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <SolutionOutlined className="db-i"/>
                                                <div className="custom-card">
                                                    <h3>Adult Clinical Evaluations</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <Row className="sr row-30px-pad-10px-top">
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.adRskStrat.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <NodeCollapseOutlined className="db-i" />
                                                <div className="custom-card">
                                                    <h3>Adult Risk Stratifications</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.pedRskStrat.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <NodeExpandOutlined className="db-i" />
                                                <div className="custom-card">
                                                    <h3>Ped. Risk Stratifications</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.clrefForm.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <FileDoneOutlined className="db-i"/>
                                                <div className="custom-card">
                                                    <h3>Client Referal forms</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.presTB.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <NodeIndexOutlined className="db-i" />
                                                <div className="custom-card">
                                                    <h3>Presumptive TB</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <Row className="sr row-30px-pad-10px-top">
                                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                            <Card className="ant-card-body pfs s-list">
                                                <div className="custom-image">
                                                    <h3 className="db-h3">{audit.clTracking.toString().replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                </div>
                                                <FileSearchOutlined className="db-i"/>
                                                <div className="custom-card">
                                                    <h3>Client Tracking</h3>
                                                </div>
                                            </Card>
                                        </Col>
                                    </Row>                           
                                </Col>
                            </Card>                            
                        </Col>
                    </Row>
                    <br />
                    <br />
                </div>                            
            </div>
        ) 
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(OnboardingAudit as any);

